import { useRef, useState } from "react";
import AnnouncementBanner from "../components/AnnouncementBanner";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import ValueProp from "../components/ValueProp";
import InvestmentAngle from "../components/InvestmentAngle";
import Combo from "../components/Combo";
import Amenities from "../components/Amenities";
import Pricing from "../components/Pricing";
import ShortTerm from "../components/ShortTerm";
import Location from "../components/Location";
import MiamiAttractions from "../components/MiamiAttractions";
import DualCTA from "../components/DualCTA";
import LeadForm from "../components/LeadForm";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import VRModal from "../components/VRModal";
import { EXPERIENCE_VALUES } from "../i18n/translations";

export default function Landing() {
    const formRef = useRef(null);
    const [vrOpen, setVrOpen] = useState(false);
    const [defaultExperience, setDefaultExperience] = useState("");

    const scrollToForm = (experience) => {
        if (experience) setDefaultExperience(experience);
        formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <div className="min-h-screen bg-charcoal text-white">
            <AnnouncementBanner />
            <Navbar onBookTour={() => scrollToForm(EXPERIENCE_VALUES.inperson)} />
            <Hero
                onBookTour={() => scrollToForm(EXPERIENCE_VALUES.inperson)}
                onVR={() => setVrOpen(true)}
            />
            <ValueProp />
            <InvestmentAngle />
            <Combo />
            <Amenities />
            <Pricing onRequest={() => scrollToForm()} />
            <ShortTerm />
            <MiamiAttractions />
            <Location />
            <DualCTA
                onBookTour={() => scrollToForm(EXPERIENCE_VALUES.inperson)}
                onVR={() => setVrOpen(true)}
            />
            <LeadForm ref={formRef} defaultExperience={defaultExperience} />
            <FinalCTA onRequest={() => scrollToForm()} />
            <Footer />
            <WhatsAppFloat />
            <VRModal
                open={vrOpen}
                onClose={() => setVrOpen(false)}
                onRequest={() => {
                    setVrOpen(false);
                    scrollToForm(EXPERIENCE_VALUES.vr);
                }}
            />
        </div>
    );
}
